/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */

// Import polyfills first (for crypto.randomUUID, global, process, etc.)
import "./polyfills";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { initConfig } from "./config/env";
import {
  getReadRelayUrls,
  getWriteRelayUrls,
} from "./config/nostr";
import { WavefuncNostrProvider } from "./lib/nostr/runtime";

// Initialize config and render app
async function startApp() {
  await initConfig();
  const readRelayUrls = getReadRelayUrls();
  const writeRelayUrls = getWriteRelayUrls();

  const elem = document.getElementById("root")!;
  const app = (
    <StrictMode>
      <WavefuncNostrProvider
        readRelays={readRelayUrls}
        writeRelays={writeRelayUrls}
      >
        <App />
      </WavefuncNostrProvider>
    </StrictMode>
  );

  console.log("📡 Read relays:", readRelayUrls);
  console.log("✍️ Write relays:", writeRelayUrls);

  if (import.meta.hot) {
    // With hot module reloading, `import.meta.hot.data` is persisted.
    const root = (import.meta.hot.data.root ??= createRoot(elem));
    root.render(app);
  } else {
    // The hot module reloading API is not available in production.
    createRoot(elem).render(app);
  }
}

startApp();
